// @ts-nocheck
import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CommonHeading from "../../components/commonComponents/commonHeading";
import CommonBreadcrumbs from "../../components/commonComponents/CommonBreadcrumbs";
import ButtonComponents from "../../components/commonComponents/ButtonComponents";
import TextFieldComponent from "../../components/commonComponents/TextFieldComponent";
import FundsBlock from "./FundsBlock";
import { useDispatch, useSelector } from "react-redux";
import { fetchAccountData, } from "../../redux/slice/ledgerSlice";
import { useNavigate } from "react-router-dom";
import BankAccountRadioGroup from "../../components/BankAccountRadioGroup";
import { handleFetchApi } from "../../utils/api";
import { useAuth } from "../../services/AuthContext";
import { PlaidLink } from "react-plaid-link";
import { linkAccount } from "../../redux/slice/accountSlice";
import { Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import loader from '../../assets/loading.png'
import { addFund, getFund, getTransactionHistory } from "../../redux/slice/fundAndTransactionSlice";
import NumberFormatter from "../../utils/NumberFormater";
import { generateGUID, numberToWords } from "../../utils/formatUtils";
import { textColor } from "../../utils/commonstyle";
import wallet from "../../assets/wallet.svg"
import { AppconfigName, getInvestorApiUrl } from "../../utils/config";
const AddFunds = () => {
  const inputRef = useRef();
  const [amount, setAmount] = useState(null);
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [selectedId, setSelectedId] = useState("");
  const [linkToken, setLinkToken] = useState(null);
  const { investorId: user } = useAuth()
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const [modelOpen, setModelOpen] = useState(false)
  const fetchPlaidLinkToken = async () => {
    try {
      // Fetch the link token from API
      const ApiResponse = await handleFetchApi({
        endpoint: 'LinkToken',
        method: 'POST',
        baseUrl:getInvestorApiUrl(),
        payload: {
          clientUserId: `${user.investorId}`,
          clientName: AppconfigName()
        },
      });
      setLinkToken(ApiResponse.data.body.link_token);
    } catch (error) {
      console.error('Error during API call:', error);
    }
  };

  const handleAccountChange = (event) => {
    console.log(event.target)
    setError("");
    setSelectedId(event.target.value);
  };


  const handleAmountChange = (event) => {
    const input = event.target;
    const rawValue = input.value.replace(/[^0-9]/g, "");
    const selectionStart = input.selectionStart;

    // Count digits before the cursor in the old value
    let digitsBeforeCursor = 0;
    for (let i = 0; i < selectionStart; i++) {
      if (/\d/.test(input.value[i])) digitsBeforeCursor++;
    }

    if (rawValue === "") {
      setAmount("");
      return;
    }

    const formattedAmount = new Intl.NumberFormat('en-US').format(Number(rawValue));
    setAmount(formattedAmount);

    // Find the new cursor position: after the same number of digits
    let newCursor = 0, digitCount = 0;
    while (newCursor < formattedAmount.length && digitCount < digitsBeforeCursor) {
      if (/\d/.test(formattedAmount[newCursor])) digitCount++;
      newCursor++;
    }
    
    // If we're at the end of the input and adding a digit, stay at the end
    if (selectionStart === input.value.length && digitsBeforeCursor === rawValue.length - 1) {
      newCursor = formattedAmount.length;
    }
    
    setTimeout(() => {
      // Access the actual input element inside the TextFieldComponent
      const inputElement = inputRef.current?.querySelector('input') || input;
      if (inputElement) {
        inputElement.setSelectionRange(newCursor, newCursor);
      }
    }, 0);
  };


  useEffect(() => {
    if (!linkToken) {
      fetchPlaidLinkToken()
    }
  }, [linkToken])

  const onSuccess = async (public_token, metadata) => {
    const payload = {
      PublicToken: public_token,
      AccountId: metadata.account.id,
      AccountName: metadata.account.name,
      PlaidTokenType: "processor",
      AccountType: metadata.account.subtype,
      BankName: metadata.institution.name,
      investorId: user.investorId,
    };

    try {
      // Dispatch the linkAccount action and wait for the response using async/await
      const response = await dispatch(linkAccount(payload)).unwrap();
      // Proceed with navigation once the response is received
      if (response.statusCode === 200 || response.statusCode === 201) {
        dispatch(fetchAccountData(user.investorId))
      }
    } catch (error) {
      console.error('Error during linkAccount dispatch:', error);
    }
  };

  const handleAddFunds = async () => {
    try {
      const newGUID = generateGUID();

      const addAmount = amount && parseInt(amount.replace(/[^0-9.]/g, ""))
      if (addAmount > 0) {
        setModelOpen(true)
        const payload = {
          investorId: user.investorId,
          amount: addAmount,
          action: "deposit_money",
          IdempotencyKey: newGUID,
          inv_Acc_Id: selectedId,
        };
        const response = await dispatch(addFund(payload)).unwrap();
        console.log(response)
        if (response.body.success) {
          dispatch(getTransactionHistory(user.investorId))
          dispatch(getFund(user.investorId))
        }
      } else {
        setError("")
      }
    } catch (error) {
      console.error(error)
      dispatch(getTransactionHistory(user.investorId))
      if (error?.body) {
        if (error?.body?.message) {
          return
        } else {
          setError(error?.body)
        }
        const id = setTimeout(() => {
          setError("");
        }, 5000)
        return () => {
          clearTimeout(id);
        }
      }
    }
  };
  const handleClose = () => {
    setModelOpen(false)
    setAmount(null)
    navigate("/managefunds", { state: { redirected: true } })
  }
  const appBreadCrumbs = [
    {
      href: "",
      label: "Home",
      onClick: () => {
        navigate("/home")
      }
    },
    {
      href: "",
      label: "Manage Funds",
      onClick: () => {
        navigate("/managefunds")
      }
    },
  ];


  return (
    <>
      <Box bgcolor={"#f8f8f8"} className="space-y-5">
        <div>
          <CommonHeading sx={{ mb: 1 }} heading={"Add Funds"} />
          <CommonBreadcrumbs
            items={appBreadCrumbs}
            final={{
              href: "",
              label: "Add Funds",
              onClick: () => {
                console.log("Manage Funds clicked");
              },
            }}
          />
        </div>

        <FundsBlock />
        <Box py={"20px"} px={5} bgcolor="#fff" boxShadow={1}>
          {/* Section for selecting the linked account */}
          <Typography variant="h6" fontSize={20} gutterBottom>
            Select Linked Account
          </Typography>
          <BankAccountRadioGroup value={selectedId} onChange={handleAccountChange} setState={setSelectedId} />
          <Box textAlign="end" data-testid="plaid-link-container">

            {linkToken ? <PlaidLink
              token={linkToken}
              onSuccess={onSuccess}
              style={{ border: "none" }}
              onExit={(error, metadata) => {
                if (error) {
                  console.error('Error:', error);
                }
              }}
            >
              <Typography
                variant="body2"
                fontSize={{ xs: 12, md: 14, xl: "1rem" }}
                mt={1}
                sx={{ cursor: "pointer", textDecoration: "underline", textAlign: "right", color: "#3b3b3b" }}
              >
                Link another account
              </Typography>
            </PlaidLink> : "loading..."}
          </Box>
          <Typography variant="h6" mt={3} gutterBottom>
            Enter Amount
          </Typography>

          <Box display="flex" flexDirection={"column"}>
            <TextFieldComponent
              error={!!error}
              label="Amount"
              value={amount}
              onChange={handleAmountChange}
              startAdornment={<Typography sx={{ mr: 1 }}>$</Typography>} // Dollar sign adornment
              sx={{ width: { xs: "100%", md: "50%" } }} // Margin bottom for spacing
              size="small"
              inputRef={inputRef}
            />
            <Typography sx={{
              fontSize: '14px',
              color: textColor.fontColor,
              fontWeight: 400,
              textAlign: 'left',
              fontStyle: "italic"
            }}>{numberToWords(amount?.replace(/,/g, ''))}  {amount?.replace(/,/g, '') > 0 && " dollars"}</Typography>
            {error && typeof error === "string" && <Typography color="#EF233C" fontStyle={"italic"} fontSize={14}>{error}</Typography>}
          </Box>
          <Box display={"flex"} mt={{ xs: 2, md: 0 }} justifyContent={{ xs: "center", md: "end" }}>
            <ButtonComponents
              sx={{ px: 3, mr: 0, fontSize: '16px' }}
              disabled={amount && parseInt(amount?.replace(/[^0-9.]/g, "")) ? false : true}
              label={"Add Funds"}
              onClick={handleAddFunds}
            />
          </Box>
        </Box>
      </Box>

      <Dialog
        open={modelOpen}
        maxWidth={"xs"}
        // sx={{width:100}}
        onClose={() => { }}
      >
        <DialogContent sx={{ padding: "25px", paddingTop: "30px", fontWeight: 500 }}>
          <DialogContentText textAlign={"center"} fontWeight={"500"} sx={{ color: "#3b3b3b" }}>
            <div className=" flex justify-center pb-4">
              <img
                style={{ marginX: "auto" }}
                width={30}
                height={30}
                src={wallet} alt="" />
            </div>
            Fund transfer of ${amount} has been initiated. We will notify you once they are available in your xBid account.
          </DialogContentText>
          <DialogActions sx={{ justifyContent: "center", p: 0 }}>
            <ButtonComponents label={"OK"} sx={{ mt: 1.5, fontSize: "16px" }} onClick={handleClose} />
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddFunds;
